/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPaymentLinkResponseDto
 */
export interface GetPaymentLinkResponseDto {
    /**
     * Stripe checkout session URL (only available when session is OPEN)
     * @type {object}
     * @memberof GetPaymentLinkResponseDto
     */
    checkoutUrl?: object | null;
    /**
     * Stripe checkout session ID
     * @type {string}
     * @memberof GetPaymentLinkResponseDto
     */
    checkoutSessionId?: string;
    /**
     * Checkout session status
     * @type {string}
     * @memberof GetPaymentLinkResponseDto
     */
    status?: GetPaymentLinkResponseDtoStatusEnum;
    /**
     * Checkout session expiration date
     * @type {object}
     * @memberof GetPaymentLinkResponseDto
     */
    checkoutExpiresAt?: object | null;
    /**
     * Stripe hosted invoice URL for viewing the invoice (only available when payment is complete)
     * @type {object}
     * @memberof GetPaymentLinkResponseDto
     */
    invoiceUrl?: object;
    /**
     * Human-readable message about the payment status
     * @type {string}
     * @memberof GetPaymentLinkResponseDto
     */
    message?: string;
}


/**
 * @export
 */
export const GetPaymentLinkResponseDtoStatusEnum = {
    Open: 'open',
    Complete: 'complete',
    Expired: 'expired'
} as const;
export type GetPaymentLinkResponseDtoStatusEnum = typeof GetPaymentLinkResponseDtoStatusEnum[keyof typeof GetPaymentLinkResponseDtoStatusEnum];


/**
 * Check if a given object implements the GetPaymentLinkResponseDto interface.
 */
export function instanceOfGetPaymentLinkResponseDto(value: object): value is GetPaymentLinkResponseDto {
    return true;
}

export function GetPaymentLinkResponseDtoFromJSON(json: any): GetPaymentLinkResponseDto {
    return GetPaymentLinkResponseDtoFromJSONTyped(json, false);
}

export function GetPaymentLinkResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentLinkResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'checkoutUrl': json['checkoutUrl'] == null ? undefined : json['checkoutUrl'],
        'checkoutSessionId': json['checkoutSessionId'] == null ? undefined : json['checkoutSessionId'],
        'status': json['status'] == null ? undefined : json['status'],
        'checkoutExpiresAt': json['checkoutExpiresAt'] == null ? undefined : json['checkoutExpiresAt'],
        'invoiceUrl': json['invoiceUrl'] == null ? undefined : json['invoiceUrl'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function GetPaymentLinkResponseDtoToJSON(json: any): GetPaymentLinkResponseDto {
    return GetPaymentLinkResponseDtoToJSONTyped(json, false);
}

export function GetPaymentLinkResponseDtoToJSONTyped(value?: GetPaymentLinkResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkoutUrl': value['checkoutUrl'],
        'checkoutSessionId': value['checkoutSessionId'],
        'status': value['status'],
        'checkoutExpiresAt': value['checkoutExpiresAt'],
        'invoiceUrl': value['invoiceUrl'],
        'message': value['message'],
    };
}

